import { api } from '@/lib/config'	

export const apiUrls = {
    busMonitoring: args => `/vehicles/${api}/${args}/detail/`,
    busMonitoringPosition: args => `/vehicles/${api}/${args}/position/`,
    busMonitoringStatus : args => `/vehicles/${api}/status/${args}/`,
    busMeasurementSummary: args =>  `impression/${api}/campaign/${args}/campaign_measurement/`,
    busVehicleSummary: args =>  `impression/${api}/campaign/${args}/vehicle_summary/`,
    busRouteSummary: args =>  `impression/${api}/campaign/${args}/route_summary/`,
    busCoverageSummary: args =>  `impression/${api}/campaign/${args}/coverage_summary/`,

}

export default {
    apiUrls
}